import moment from "moment";
import React from "react";
import { Fragment } from "react";
import { useEffect, useState } from "react";

const useEmpTableEle = (empList,handleEmpEdit,handleDeleteEmployee) => {
  const [trow, setTrow] = useState([]);
  const [thead] = useState([
    "Name",
    // "Employee Id",
    "Email",
    "Mobile",
    "Join Date",
    "Role",
    "Leave Assigned",
    "Action",
  ]);

  useEffect(() => {
    let trow = empList.map((emp, i) => {
      return {
        Name: (
          <h2 className="table-avatar">
            <img
              className="profile-img-table"
              alt=""
              src={require(`../../../img/employee/user.png`)}
            />
            <span className="ml-2">
              <span style={{ fontWeight: "600", color: "black" }}>
                {emp.value.employeeName}
              </span>
              <span> {emp.value.designationName}</span>
            </span>
          </h2>
        ),
        // "Employee Id": (
        //   <div style={{ width: "106px" }}>{emp.value.employeeId}</div>
        // ),
        Email: emp.value.primaryMailId,
        Mobile: <div style={{ width: "71px" }}>{(emp.value.mobileNumber === null || emp.value.mobileNumber === 'null') ? "" :emp.value.mobileNumber}</div>,
        "Join Date":moment(emp.value.dateOfJoin).format("DD-MM-YYYY"),
        Role: (
          <div style={{ minWidth: "auto" }}>{emp.value.designationName}</div>
        ),
        "Leave Assigned": (
          <div style={{ minWidth: "auto" }}>{emp.value.leaveAssignedName}</div>
        ),
        Action: (
          <Fragment>
             <i
              className="fas fa-edit ml-4"   
              style={{ marginRight: "10px", cursor: "pointer" }}           
              onClick={() => {
                handleEmpEdit(emp.value);

             }}
            ></i>
             <i
              className="fas fa-trash"
              onClick={() => handleDeleteEmployee(emp.value.employeeId)}
            ></i>
           
          </Fragment>
        ),
      };
    });

    setTrow(trow);
  }, [empList]);
  return { thead, trow };
};

export default useEmpTableEle;
